import { Component, OnInit, ViewChild, Directive, Input, AfterViewInit, ElementRef } from "../../../../../../node_modules/@angular/core";
import { Router, ActivatedRoute } from "../../../../../../node_modules/@angular/router";
import { LoginRest } from "../../../../login/login.rest";
import { UserDetailsRest } from "../user-details.rest";
import { MessageBoxComponent } from '../../../../core/shared/message-box.component';
import { ProfilePictureService } from "../../../../profile-picture/profile-picture.service";
import { HasPermissions, Permissions } from "../../../../core/services/permissions/permissions.model";
import { PermissionsService } from "../../../../core/services/permissions/permissions.service";
import { NgForm, NgModel, NG_VALIDATORS, Validator, AbstractControl, ValidatorFn } from '@angular/forms';
import { User } from "../../users.model";
import { ObjectToSelect } from "../../../../core/shared/objectToSelect.model";
import { StructureUser } from "../../../structure/structure-users.model";
import { IssuesRest } from "../../../../issues/issues.rest";
import { DateInputModel } from "../../../../core/shared/date-input/date-input.model";
import { INgxSelectOption } from "ngx-select-ex";
import { stringify } from "querystring";

@Component({
    selector: 'smp-user-header',
    templateUrl: 'user-details-header.component.html',
    styleUrls: ['../../user-details/user-details.component.scss']
})

export class UserDetailsHeaderComponent implements OnInit, HasPermissions {

    permissions: Permissions;

    @ViewChild('valForm') public valForm: NgForm;
    public test: NgModel;
    public user: User;
    public isNew: boolean;

    private hide: boolean = true;
    private hideReapeted: boolean = true;

    private employees: ObjectToSelect[];
    private roles: ObjectToSelect[];
    private superiors: StructureUser[];
    private departments: ObjectToSelect[];

    public deactivateDate: DateInputModel;
    public selectedFile: string = 'Nie wybrano pliku';
    public messageBox: MessageBoxComponent;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private loginRest: LoginRest,
        private issueRest: IssuesRest,
        private rest: UserDetailsRest,
        private profilePictureService: ProfilePictureService,
        private permissionService: PermissionsService) {
    }

    setPermissions(claimType: string): void {
        this.permissions = this.permissionService.getUserPermissions(claimType);
    }

    ngOnInit() {
        this.setPermissions("User");
        this.initializeDate();
    }

    public setModel(userDetailsModel: any, isNew: boolean, messageBox: MessageBoxComponent) {
        this.user = userDetailsModel;
        if (isNew) {
            this.user.password = '';
            this.user.repeatedPassword = '';
        }
        this.isNew = isNew;
        this.messageBox = messageBox;
        this.getEmployees();
        this.getRoles();

        if (this.user.deactivateDate != null) {
            this.deactivateDate.value = new Date(this.user.deactivateDate);
        }

    }

    private getEmployees() {
        this.rest.getEmployeesRows().subscribe(employees => {
            this.employees = employees;
        });
    }

    private getRoles() {
        this.rest.getSelectRoles().subscribe(roles => {
            this.roles = roles;
        });
    }

    public onFileChanged(files: any[]) {
        if (!files || !this.permissions.canEdit)
            return;

        var reader = new FileReader();
        if ((files[0] as File).size > 1048576) {
            this.messageBox.openMessageBox("Błąd", "Wielkość pliku nie może przekraczać 1 MB")
            return;
        }
        reader.readAsArrayBuffer(files[0]);
        reader.onload = () => {
            let binaryString = ''
            let arrayBuffer = reader.result as ArrayBuffer;
            let array = new Uint8Array(arrayBuffer);
            for (var i = 0; i < array.byteLength; i++) {
                binaryString += String.fromCharCode(array[i]);
            }
            this.user.picture = window.btoa(binaryString);
            this.selectedFile = files[0].name;
            let data = { userId: this.user.id, picture: this.user.picture };
            const action = this.rest.editUserPicture;
            action.call(this.rest, data).subscribe(() => {
                this.updateProfilePicture(this.user.picture);
                sweetAlert({ text: "Zmieniono zdjęcie profilowe użytkownika" });
            });
        }
    }

    private updateProfilePicture(picture: string) {
        this.profilePictureService.changePicture(picture);
    }

    public isValid() {
        return this.valForm.valid;
    }

    public onEmployeeSelected(employeeId: number) {
        if (employeeId > 0) {
            this.rest.getEmployee(employeeId).subscribe(employee => {
                this.user.firstName = employee.name ? employee.name.trimRight() : '';
                this.user.lastName = employee.surname ? employee.surname.trimRight() : '';
                this.user.fullName = employee.fullName ? employee.fullName.trimRight() : employee.name + ' ' + employee.surname;
                this.user.email = employee.email ? employee.email.trimRight() : '';
                this.user.phoneNumber = employee.phone ? employee.phone.trimRight() : '';
                this.user.name = employee.email ? employee.email.trimRight() : '';
                this.user.isForeignEmployee = employee.isForeignEmployee;
            });
        } else {
            this.user.firstName = '';
            this.user.lastName = '';
            this.user.fullName = '';
            this.user.email = '';
            this.user.phoneNumber = null;
            this.user.name = '';
            this.user.numeratorSerie = '';
            this.user.isForeignEmployee = null;
        }
    }

    private initializeDate() {
        this.deactivateDate = new DateInputModel();
        this.deactivateDate.isReadOnly = true;
        this.deactivateDate.isRequired = false;
        this.deactivateDate.name = 'Czas deaktywacji';
        this.deactivateDate.value = null;
        this.deactivateDate.withTime = true;
        this.deactivateDate.internalName = 'DeactivateDate';
    }

    private onElementValidation(element, isValid: boolean) {

        if (!element) {
            return;
        }

        if (element.internalName === 'DeactivateDate') {
            this.user.deactivateDate = element.value;
        }
    }

    private searchCallback(search: string, item: INgxSelectOption): boolean {
        search = search.toLowerCase();
        return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
    }
}
